import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {_DetailResolver} from './_detail.resolver';
import {UserService} from '../service';
import {User, UUID} from '../../model';

@Injectable()
export class UserDetailResolver extends _DetailResolver<User, UUID> {
  constructor(router: Router, toastr: ToastrService, service: UserService) {
    super(router, toastr, service, 'user');
  }
}
